import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  // View actions
  registerUpdatePhoto: ['imgBase64', 'fileType', 'procedureId'],
  // Reducer
  registerUpdatePhotoClear: null,
  registerUpdatePhotoRequest: null,
  registerUpdatePhotoSuccess: null,
  registerUpdatePhotoFailure: ['error']
});

export { Creators, Types };
